// Carries the "blocked by payment" notice across the forced logout: when the API rejects an
// already-authenticated request with 401 PAYMENT_BLOCKED the session is cleared, and the login
// screen shows how to pay instead of a generic sign-in form.
const STORAGE_KEY = 'paymentBlockedNotice';

export const PAYMENT_BLOCKED_CODE = 'PAYMENT_BLOCKED';

// A notice is only meaningful right after the forced logout; an old one would block the login form for no reason.
export const PAYMENT_BLOCKED_NOTICE_TTL_MS = 10 * 60 * 1000;

export function savePaymentBlockedNotice(data) {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        amount: data?.nextPaymentAmount ?? null,
        dueDate: data?.nextPaymentDueDate ?? null,
        savedAt: Date.now(),
      }),
    );
  } catch {
    // Storage unavailable (private mode): the login screen simply won't show the notice.
  }
}

export function readPaymentBlockedNotice() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const notice = raw ? JSON.parse(raw) : null;
    if (!notice) return null;
    if (!Number.isFinite(notice.savedAt) || Date.now() - notice.savedAt > PAYMENT_BLOCKED_NOTICE_TTL_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return { amount: notice.amount ?? null, dueDate: notice.dueDate ?? null };
  } catch {
    return null;
  }
}

export function clearPaymentBlockedNotice() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
